import { gsap } from "gsap";

const animationLeave = (container) => {
  return gsap.from(container, { autoAlpha: 0, duration: 1.5, clearProps: 'all', ease: 'none' })
}

export default animationLeave;
